module.exports = "https://portperrypedals.ca/_res/img/pet-ct.bf96580.jpg";